export const HYPHENATION_SETTINGS = {
    hyphenateLimitChars: "10 5 5",
    hyphenateLimitLast: "always",
    hyphenateLimitLines: 1,
    hyphenateLimitZone: "8%",
    hyphens: "auto",
    MozHyphens: "auto",
    MozHyphensLimitChars: "10 5 5",
    MozHyphensLimitLast: "always",
    MozHyphensLimitLines: 1,
    MozHyphensLimitZone: "8%",
    msHyphenateLimitChars: "10 5 5",
    msHyphenateLimitLast: "always",
    msHyphenateLimitLines: 1,
    msHyphenateLimitZone: "8%",
    msHyphens: "auto",
    WebkitHyphenateLimitChars: "10 5 5",
    WebkitHyphenateLimitCharsAfter: 5,
    WebkitHyphenateLimitCharsBefore: 5,
    WebkitHyphenateLimitLast: "always",
    WebkitHyphenateLimitLines: 1,
    WebkitHyphenateLimitZone: "8%",
    WebkitHyphens: "auto",
};
//# sourceMappingURL=hyphenation.js.map